import React from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import AlertDescriptionView from 'pages/AlertLookup/AlertDescriptionView'

import { Button } from '@nexiahome/ui-common/components/primitives/buttons'
import Modal from 'components/Modal'

import { alertCodeDisplayValue } from 'helpers/alerts'

import { AlertDescription } from 'types/Alert'

import { color } from 'styles/colors'

type Props = {
  isDisplayed: boolean;
  alertDescription: AlertDescription;
  query: string | null;
}

const AdminAlertDescriptionModal = ({ isDisplayed, alertDescription, query = null }: Props) => {
  const navigate = useNavigate()

  return (
    <Modal isDisplayed={isDisplayed} closeCallback={() => { navigate(`/alerts?q=${query}`) }}>
      {alertDescription && (
        <AlertDescriptionView
          alertDescription={alertDescription}
          adminComponent={
            <S.DraftContainer>
              {alertDescription.draft && <S.Draft>Draft</S.Draft>}
              <Button decoration="secondary" text="Edit" onPress={() => navigate(`/alerts/${alertCodeDisplayValue(alertDescription.code).toUpperCase()}/edit${query ? `?q=${query}` : ''}`)} />
            </S.DraftContainer>
          }
        />
      )}
    </Modal>
  )
}

export default AdminAlertDescriptionModal

const S = {
  DraftContainer: styled.div`
    display: inline-flex;
  `,
  Draft: styled.div`
    display: inline-block;
    margin-right: 30px;
    padding: 5px 10px;
    background-color: ${color('draftAlert')};
    color: ${color('draftAlertText')};
    border-radius: 3px
  `
}
